import { render, staticRenderFns } from "./PurchaseItem.vue?vue&type=template&id=b1e6b5ba&"
import script from "./PurchaseItem.vue?vue&type=script&lang=ts&"
export * from "./PurchaseItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports